import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { decryptFromStore } from "../../helper/sessionStore";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
const CourseResults = () => {
    const { t } = useTranslation("BusinessCourseResults");
    const navigate = useNavigate();
    const location = useLocation();
    const [QuizAns, setQuizAns] = useState({});

    const getResults = () => {
        const result = decryptFromStore("businessQuizAnswer");
        setQuizAns(result);
    };

    useEffect(() => {
        if (!location?.state?.trailId) {
            navigate("/sign-in");
            return;
        }
        getResults();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const formatDuration = (timeString) => {
        if (typeof timeString !== "string" || timeString.length === 0) {
            // Handle invalid input
            return t("invalid_time");
        }

        const parts = timeString.split(":").map((part) => parseInt(part, 10));
        const hours = parts[0];
        const minutes = parts[1];
        const seconds = parts.length > 2 ? parts[2] : 0;

        let formattedTime = "";
        const hourText = hours > 1 ? t("hours") : t("hour");
        const minuteText = minutes > 1 ? t("minutes") : t("minute");
        const secondText = seconds > 1 ? t("seconds") : t("second");

        if (hours > 0) {
            formattedTime += `${hours} ${hourText} `;
        }
        if (minutes > 0 || (hours > 0 && seconds > 0)) {
            formattedTime += `${minutes} ${minuteText} `;
        }
        if (seconds > 0) {
            formattedTime += `${seconds} ${secondText}`;
        }

        return formattedTime.trim();
    };
    const handleNavigate = (path) => {
        sessionStorage.removeItem("businessCourse");
        navigate(path, {
            state: {
                step: true,
                trailId: location?.state?.trailId,
                name: location?.state?.name,
                userData: location?.state?.userData,
            },
        });
    };

    return (
        <>
            <Header />
            <main className="business_course_results business_public_spaces business_results">
                <section>
                    <div className="featured-main">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-md-12 col-lg-8 col-xl-7">
                                    <h3>{QuizAns?.courseName}</h3>
                                    <div className="card linear-gradient girlimge rounded-3 border-0 position-relative">
                                        <div className="card-body px-4 pt-5">
                                            <div className="d-flex justify-content-center">
                                                <img
                                                    src="/featured-courses/girl-party.jpg"
                                                    alt=""
                                                />
                                            </div>
                                            <h6 className="text-center pt-4 pt-md-5 fw-600 text-black">
                                                {t("you")}{" "}
                                                {QuizAns?.score >= 80
                                                    ? t("passed")
                                                    : t("failed")}{" "}
                                            </h6>
                                            <h2 className="text-center">
                                                {QuizAns?.score >= 80
                                                    ? t("pass")
                                                    : t("fail")}{" "}
                                                {t("with")} {QuizAns?.score}%{" "}
                                                {t("score")}
                                            </h2>
                                            <p className="text-center text-black text-black pt-4 fs-5 mb-0 fw-600">
                                                {t("timetaken")}
                                            </p>

                                            <div className="row justify-content-center g-0">
                                                <div className="col-12 col-md-7 col-lg-7 col-xl-6">
                                                    <button
                                                        type="button"
                                                        className="btn-explore p-sm-15 text-white text-center rounded-2 w-100 mt-2 mb-3"
                                                    >
                                                        {formatDuration(
                                                            QuizAns?.taken_time
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h3 className="fw-500 mb-4">
                                        {t("yougot")} {QuizAns?.points}{" "}
                                        {t("outof10questionsright")}
                                    </h3>
                                    <h6 className="fw-400 mb-3">
                                        {t("moredetailsonthegrade")}
                                    </h6>
                                    <p className="text-center text-black fs-6 mb-0 fw-400">
                                        {t("you_got_it")} {QuizAns?.score}%{" "}
                                        {t("feedback_answer_right")}
                                    </p>

                                    <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 m-auto mt-4 mt-md-5">
                                        <button
                                            className="replay"
                                            onClick={() => {
                                                handleNavigate(
                                                    "/free-trail/course"
                                                );
                                            }}
                                        >
                                            {t("replay")}
                                        </button>
                                        <button
                                            onClick={() =>
                                                handleNavigate(
                                                    "/free-trail/puzzle"
                                                )
                                            }
                                            className="start_courses_btn d-flex justify-content-between align-items-center gap-4"
                                        >
                                            {t("startpuzzle")}
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={22}
                                                height={14}
                                                viewBox="0 0 22 14"
                                                fill="none"
                                            >
                                                <path
                                                    d="M1 6.99854H21L16 1"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                <path
                                                    d="M21 6.99805L16 12.9995"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="d-flex justify-content-center align-items-center mt-4 still_questions">
                                        <span>
                                            {t("stillhavequestions")}{" "}
                                            <Link
                                                to="/free-trail/ask-to-ai"
                                                state={{
                                                    step: true,
                                                    trailId:
                                                        location?.state
                                                            ?.trailId,
                                                    name: location?.state?.name,
                                                    userData:
                                                        location?.state
                                                            ?.userData,
                                                }}
                                            >
                                                {t("clickhere")}
                                            </Link>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default CourseResults;
